import { useEffect, useState } from 'react'
import { Autocomplete, FormControl, InputLabel, TextField } from '@mui/material'
import { getObjectsWithFilter } from '../../api/apiClientCrud'

function FreeSelectField({ field, isTable, optionsAPI, onChangeF, dataId, isError, editRow, onRowDataChange }) {
  const [select, setSelect] = useState([])
  const [inputText, setInputText] = useState('')
  const [value, setValue] = useState(null)

  const generateId = () => Math.floor(Math.random() * 2147483647)

  useEffect(() => {
    let isMounted = true
    const fetchOptions = async () => {
      try {
        const res = await getObjectsWithFilter(optionsAPI.api, optionsAPI.filter())
        if (!isMounted) return
        setSelect(res.data[optionsAPI.api] ?? res.data)
      } catch (e) {}
    }
    fetchOptions()
    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (!editRow) return
    if (editRow[dataId] != null) {
      const current = select.find((item) => item[dataId] === editRow[dataId])
      if (current) {
        setValue(current)
        setInputText(current[field.name])
        return
      }
    }

    if (editRow[field.name]) {
      const existing = select.find((item) => item[field.name] === editRow[field.name])
      if (!existing) {
        const newId = generateId()
        const newItem = { id: newId, [dataId]: newId, [field.name]: editRow[field.name] }
        setSelect((prev) => [...prev, newItem])
        setValue(newItem)
        setInputText(editRow[field.name])
        onRowDataChange({ ...editRow, [dataId]: newId })
      } else {
        setValue(existing)
        setInputText(existing[field.name])
      }
    } else {
      setValue(null)
      setInputText('')
    }
  }, [editRow, select])

  const handleChange = (event, selectedValue) => {
    if (!editRow) return

    const data = { ...editRow }
    if (selectedValue) {
      data[dataId] = selectedValue.id
      data[field.name] = selectedValue[field.name]
      setValue(selectedValue)
      setInputText(selectedValue[field.name])
    } else {
      data[dataId] = null
      data[field.name] = null
      setValue(null)
      setInputText('')
    }

    onRowDataChange(data)
    onChangeF?.(data, select, onRowDataChange)
  }

  return (
    <FormControl sx={{ my: 1, minWidth: 120 }}>
      {(editRow?.[field.name] == null || editRow?.[field.name] === '') && !isTable && (
        <InputLabel sx={{ position: 'absolute', mt: 0.5, color: '#A4A2A2' }}>{field.label}</InputLabel>
      )}
      <Autocomplete
        options={select || []}
        value={value}
        freeSolo
        inputValue={inputText}
        onInputChange={(event, newInputValue) => setInputText(newInputValue)}
        getOptionLabel={(option) => option?.[field.name] ?? ''}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant='standard'
            error={isError}
            onBlur={(e) => {
              const val = e.target.value.trim()
              if (val && !select?.some((item) => item[field.name] === val)) {
                const newId = generateId()
                handleChange(null, { id: newId, [dataId]: newId, [field.name]: val })
                setInputText(val)
              }
            }}
            inputProps={{
              ...params.inputProps,
              onKeyDown: (e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  e.stopPropagation()
                  e.nativeEvent.stopImmediatePropagation()
                }
              }
            }}
          />
        )}
      />
    </FormControl>
  )
}

export default FreeSelectField
